import { Link } from 'react-router-dom';
import classNames from 'classnames';

const MenuItem = ({
  text,
  link,
  key,
  customClasses = '',
  decorationClasses = '',
  action,
}) => {
  return (
    <div
      key={key}
      className={classNames(
        'text-[15px] text-blue-800 hover:text-blue-900 relative group inline-block',
        customClasses,
      )}
    >
      {action ? (
        <div onClick={action} className="relative cursor-pointer">
          {text}
        </div>
      ) : (
        <Link to={link} className="relative">
          {text}
        </Link>
      )}

      <span
        className={classNames(
          'absolute bottom-[-2px] left-0 w-0 h-[1px] bg-blue-900 group-hover:w-full group-hover:transition-all group-hover:duration-300',
          decorationClasses,
        )}
      ></span>
    </div>
  );
};

export default MenuItem;
